import { ReactNode } from "react";

import { IExtendableDto } from "@ryde/shared";

import { TableItem } from "./table.item";

interface ITableItemNoGroupProps<T extends IExtendableDto> {
  groupingValue: T[keyof T] | undefined | null;
}

export const TableItemNoGroup = <T extends IExtendableDto>({
  groupingValue,
}: ITableItemNoGroupProps<T>): ReactNode => {
  return <TableItem groupingValue={groupingValue} tableIndex={0} />;
};
